import React from 'react';
var TargettedSystemContext = React.createContext(null);
export var ThemeProvider = TargettedSystemContext.Provider;
export var ThemeConsumer = TargettedSystemContext.Consumer;
export default TargettedSystemContext;
//# sourceMappingURL=targetted-system-context.js.map